import axios from 'axios';
import { GET_INVITATIONS, ADD_INVITATION, UPDATE_INVITATION, DELETE_INVITATION, INVITATIONS_LOADING, GET_INVITATION_FILTER_VALUES } from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getInvitations = (filters = {}, options = {}) => (dispatch, getState) => {
  dispatch(setInvitationsLoading());

  // Build query parameters
  const params = new URLSearchParams();
  if (options.page) params.append('page', options.page);
  if (options.limit) params.append('limit', options.limit);
  if (filters.status && filters.status.length) params.append('status', filters.status.join(','));
  if (filters.role && filters.role.length) params.append('role', filters.role.join(','));
  if (filters.emails && filters.emails.length) params.append('emails', filters.emails.join(','));
  if (filters.groups && filters.groups.length) params.append('groups', filters.groups.join(','));
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);

  const queryString = params.toString();
  const url = queryString ? `/api/invitations?${queryString}` : '/api/invitations';

  axios
    .get(url, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_INVITATIONS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const getInvitationFilterValues = () => (dispatch, getState) => {
  axios
    .get('/api/invitations/filter-values', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_INVITATION_FILTER_VALUES,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const addInvitation = invitation => (dispatch, getState) => {
  axios
    .post('/api/invitations', invitation, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: ADD_INVITATION,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const addBulkInvitations = (invitationsData) => (dispatch, getState) => {
  axios
    .post('/api/invitations/bulk', { invitations: invitationsData }, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_INVITATIONS,
        payload: res.data.invitations || res.data
      });
      
      // You could also dispatch a notification action here to show the results
    })
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const updateInvitation = (id, invitation) => (dispatch, getState) => {
  axios
    .put(`/api/invitations/${id}`, invitation, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: UPDATE_INVITATION,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const deleteInvitation = id => (dispatch, getState) => {
  axios
    .delete(`/api/invitations/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_INVITATION,
        payload: id
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const setInvitationsLoading = () => {
  return {
    type: INVITATIONS_LOADING
  };
};
